import { render, staticRenderFns } from "./Onderstations.vue?vue&type=template&id=76dbe31c"
import script from "./Onderstations.vue?vue&type=script&lang=js"
export * from "./Onderstations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports